import { useState, useEffect } from 'react'
import clsx from 'clsx'

const DELAY_ANIMATION_TIME = 20
const ANIMATION_TIME = 200

export default function PopupContainer({
  className,
  children,
  show,
  hidePopupCallback = () => {}
}) {
  const [showElement, setShowElement] = useState(false)
  const [active, setActive] = useState(false)

  useEffect(() => {
    if (show) {
      setShowElement(true)
      setTimeout(() => setActive(true), DELAY_ANIMATION_TIME)
    } else {
      setActive(false)
      setTimeout(() => setShowElement(false), ANIMATION_TIME)
    }
  }, [show])

  const onPopupClose = () => {
    setActive(false)
    setTimeout(() => {
      setShowElement(false)
      hidePopupCallback()
    }, ANIMATION_TIME)
  }

  return (
    <div
      className={clsx('popup-card-overlay', {
        show: showElement,
        active
      })}
    >
      <div className={clsx('popup-card', className)}>
        {children}
        <div className="popup-card-close-button" onClick={onPopupClose} />
      </div>
    </div>
  )
}
